export default __webpack_public_path__ + "static/media/lunchtime-lounge.0077250c.mp3";